(function() { module.exports = window["Next"]["Drawer"]; }());